export const DateConstants = {
  DATE_FORMAT_SHOW: 'DD/MM/YYYY',
  CALENDAR_DATE_FORMAT: 'dd/mm/yy',
  SERVER_NODATIME_INSTANT_FORMAT: 'YYYY-MM-DDTHH:mm:ss[Z]',
  SERVER_NODATIME_LOCAL_DATE_FORMAT: 'YYYY-MM-DD',
  SERVER_NODATIME_LOCAL_DATE_TIME_FORMAT: 'YYYY-MM-DDTHH:mm:ss',
};
